import { default as indexri4oggYEhHMeta } from "/opt/portal/xyy-web/src/pages/car/index.vue?macro=true";
import { default as search_46clientk6akyTu8XrMeta } from "/opt/portal/xyy-web/src/pages/car/search.client.vue?macro=true";

let _createClientPage
async function createClientPage(loader) {
  _createClientPage ||= await import("/opt/portal/xyy-web/node_modules/.pnpm/nuxt@3.13.2_@parcel+watcher@2.4.1_@types+node@22.7.3_ioredis@5.4.1_magicast@0.3.5_rollup@4.22_cp5tigeaydejqm7rupsw4b2s4i/node_modules/nuxt/dist/components/runtime/client-component").then(r => r.createClientPage)
  return _createClientPage(loader);
}
import { default as submit_45order_46client8YB4mhm5OJMeta } from "/opt/portal/xyy-web/src/pages/car/submit-order.client.vue?macro=true";
import { default as ActiveMessage6QSOQRYM0dMeta } from "/opt/portal/xyy-web/src/pages/chat/components/ActiveMessage.vue?macro=true";
import { default as ApplyJoinGroup5TeTn7cWMNMeta } from "/opt/portal/xyy-web/src/pages/chat/components/ApplyJoinGroup.vue?macro=true";
import { default as ApplyJoinListnQlelRzXWmMeta } from "/opt/portal/xyy-web/src/pages/chat/components/ApplyJoinList.vue?macro=true";
import { default as ChatOrvuQs5E8cMeta } from "/opt/portal/xyy-web/src/pages/chat/components/Chat.vue?macro=true";
import { default as ChatHistoryjuQHz3jPc3Meta } from "/opt/portal/xyy-web/src/pages/chat/components/ChatHistory.vue?macro=true";
import { default as ChatListeduyEa4A64Meta } from "/opt/portal/xyy-web/src/pages/chat/components/ChatList.vue?macro=true";
import { default as Complaini7sLuBdRN2Meta } from "/opt/portal/xyy-web/src/pages/chat/components/Complain.vue?macro=true";
import { default as ContextMenunoWjyTYAzRMeta } from "/opt/portal/xyy-web/src/pages/chat/components/ContextMenu.vue?macro=true";
import { default as CreateGroupSjQOZe5vtJMeta } from "/opt/portal/xyy-web/src/pages/chat/components/CreateGroup.vue?macro=true";
import { default as FansList2S6Uwkze4DMeta } from "/opt/portal/xyy-web/src/pages/chat/components/FansList.vue?macro=true";
import { default as FriendInfoZU6y9pQhHAMeta } from "/opt/portal/xyy-web/src/pages/chat/components/FriendInfo.vue?macro=true";
import { default as GroupInfojvmEukXvHeMeta } from "/opt/portal/xyy-web/src/pages/chat/components/GroupInfo.vue?macro=true";
import { default as GroupIntroBR1wz8jEYGMeta } from "/opt/portal/xyy-web/src/pages/chat/components/GroupIntro.vue?macro=true";
import { default as GroupQrCodert5Lt4c9qiMeta } from "/opt/portal/xyy-web/src/pages/chat/components/GroupQrCode.vue?macro=true";
import { default as GroupSettingzaV1yQ3a1rMeta } from "/opt/portal/xyy-web/src/pages/chat/components/GroupSetting.vue?macro=true";
import { default as GroupSquareLrQIXUrDAuMeta } from "/opt/portal/xyy-web/src/pages/chat/components/GroupSquare.vue?macro=true";
import { default as GroupTipsDiez8vfjHEMeta } from "/opt/portal/xyy-web/src/pages/chat/components/GroupTips.vue?macro=true";
import { default as InviteGroupBWTKVIskpdMeta } from "/opt/portal/xyy-web/src/pages/chat/components/InviteGroup.vue?macro=true";
import { default as MsgStatussIGU8Mkk3kMeta } from "/opt/portal/xyy-web/src/pages/chat/components/MsgStatus.vue?macro=true";
import { default as NewFansl9agMUVIWGMeta } from "/opt/portal/xyy-web/src/pages/chat/components/NewFans.vue?macro=true";
import { default as RemoveMembervSmYeFp4JOMeta } from "/opt/portal/xyy-web/src/pages/chat/components/RemoveMember.vue?macro=true";
import { default as SetGroupTypetQTkPulO9mMeta } from "/opt/portal/xyy-web/src/pages/chat/components/SetGroupType.vue?macro=true";
import { default as SystemMessageMhsZzvvYZjMeta } from "/opt/portal/xyy-web/src/pages/chat/components/SystemMessage.vue?macro=true";
import { default as TextMsgIyyOQCWqA2Meta } from "/opt/portal/xyy-web/src/pages/chat/components/TextMsg.vue?macro=true";
import { default as constetBtPCNkCqMeta } from "/opt/portal/xyy-web/src/pages/chat/const.js?macro=true";
import { default as emojipteT2myHJdMeta } from "/opt/portal/xyy-web/src/pages/chat/emoji.js?macro=true";
import { default as followSta95mDuCZy9yMeta } from "/opt/portal/xyy-web/src/pages/chat/followSta.js?macro=true";
import { default as friends_mockjGnwW20CZIMeta } from "/opt/portal/xyy-web/src/pages/chat/friends_mock.js?macro=true";
import { default as groupTypeList67XUks3Zp5Meta } from "/opt/portal/xyy-web/src/pages/chat/groupTypeList.js?macro=true";
import { default as indexbIfrU4O1SKMeta } from "/opt/portal/xyy-web/src/pages/chat/index.vue?macro=true";
import { default as _91id_93iVXnU3kN08Meta } from "/opt/portal/xyy-web/src/pages/house/article/[id].vue?macro=true";
import { default as index_46client9d4qDQeaOYMeta } from "/opt/portal/xyy-web/src/pages/house/index.client.vue?macro=true";
import { default as _91id_938SY9eyqtVtMeta } from "/opt/portal/xyy-web/src/pages/house/newHouse/[id].vue?macro=true";
import { default as _91id_93o2H5PHiSqhMeta } from "/opt/portal/xyy-web/src/pages/house/oldHouse/[id].vue?macro=true";
import { default as _91id_93KtL9HqqUgaMeta } from "/opt/portal/xyy-web/src/pages/house/rentHouse/[id].vue?macro=true";
import { default as indexWe12s7AYzUMeta } from "/opt/portal/xyy-web/src/pages/index.vue?macro=true";
import { default as _91id_93QQheKyp5IoMeta } from "/opt/portal/xyy-web/src/pages/labour-detail/[id].vue?macro=true";
import { default as indexPH6h6qwMmIMeta } from "/opt/portal/xyy-web/src/pages/labour/index.vue?macro=true";
import { default as index_46clientrbucbSTYbxMeta } from "/opt/portal/xyy-web/src/pages/login/index.client.vue?macro=true";
import { default as index_46client4MVqKfoissMeta } from "/opt/portal/xyy-web/src/pages/note-create-start/index.client.vue?macro=true";
import { default as index_46clientb5haEA0EtIMeta } from "/opt/portal/xyy-web/src/pages/note-create/index.client.vue?macro=true";
import { default as successH6trLEzvusMeta } from "/opt/portal/xyy-web/src/pages/note-create/success.vue?macro=true";
import { default as addGroupOh2ZX8dA5AMeta } from "/opt/portal/xyy-web/src/pages/other-people-center/components/addGroup.vue?macro=true";
import { default as index_46client9reeEObqilMeta } from "/opt/portal/xyy-web/src/pages/other-people-center/index.client.vue?macro=true";
import { default as _91id_93_46client06VNYvNbfOMeta } from "/opt/portal/xyy-web/src/pages/profile/car-order/[id].client.vue?macro=true";
import { default as followListsSpwcRmKruMeta } from "/opt/portal/xyy-web/src/pages/profile/components/followModal/followList.vue?macro=true";
import { default as indexJKsJFXsnFiMeta } from "/opt/portal/xyy-web/src/pages/profile/components/followModal/index.vue?macro=true";
import { default as commentsV8IxITwq4dMeta } from "/opt/portal/xyy-web/src/pages/profile/components/profileCollection/comments.vue?macro=true";
import { default as contentItempdktFZTy4bMeta } from "/opt/portal/xyy-web/src/pages/profile/components/profileCollection/contentItem.vue?macro=true";
import { default as topics2MFV6PNK4vMeta } from "/opt/portal/xyy-web/src/pages/profile/components/profileCollection/topics.vue?macro=true";
import { default as travelNotesgwMkiXgLClMeta } from "/opt/portal/xyy-web/src/pages/profile/components/profileCollection/travelNotes.vue?macro=true";
import { default as car_45orders2qSr5UPPLwMeta } from "/opt/portal/xyy-web/src/pages/profile/index/car-orders.vue?macro=true";
import { default as collectionhh4eINBDcaMeta } from "/opt/portal/xyy-web/src/pages/profile/index/collection.vue?macro=true";
import { default as labour_45ordersE323mWeDt0Meta } from "/opt/portal/xyy-web/src/pages/profile/index/labour-orders.vue?macro=true";
import { default as my_45commentbT3vYGtgCgMeta } from "/opt/portal/xyy-web/src/pages/profile/index/my-comment.vue?macro=true";
import { default as notestI0tZLrlETMeta } from "/opt/portal/xyy-web/src/pages/profile/index/notes.vue?macro=true";
import { default as travel_45orderskWxfpHkoHyMeta } from "/opt/portal/xyy-web/src/pages/profile/index/travel-orders.vue?macro=true";
import { default as _91id_932lEvQKTYLhMeta } from "/opt/portal/xyy-web/src/pages/profile/index/visa-order-details/[id].vue?macro=true";
import { default as visa_45ordersJArIx3M3vdMeta } from "/opt/portal/xyy-web/src/pages/profile/index/visa-orders.vue?macro=true";
import { default as wallet4UTAHszrAuMeta } from "/opt/portal/xyy-web/src/pages/profile/index/wallet.vue?macro=true";
import { default as index_46clienttqQ4DCnTbEMeta } from "/opt/portal/xyy-web/src/pages/profile/index.client.vue?macro=true";
import { default as _91id_93L6bZKxV3NtMeta } from "/opt/portal/xyy-web/src/pages/profile/travel-order/[id].vue?macro=true";
import { default as indexevlRaKVg49Meta } from "/opt/portal/xyy-web/src/pages/profile/userinfo/index.vue?macro=true";
import { default as _91id_93TmYtKTNQWkMeta } from "/opt/portal/xyy-web/src/pages/t/[id].vue?macro=true";
import { default as indexbSnndUZP9vMeta } from "/opt/portal/xyy-web/src/pages/t/index.vue?macro=true";
import { default as index_46client8vAtygO4EeMeta } from "/opt/portal/xyy-web/src/pages/topic/index.client.vue?macro=true";
import { default as index_46clientjuWz46MY4zMeta } from "/opt/portal/xyy-web/src/pages/travel-notes/index.client.vue?macro=true";
import { default as indexzNnJm3wJA5Meta } from "/opt/portal/xyy-web/src/pages/travel-projects/index.vue?macro=true";
import { default as _91id_939Wj9hstzyKMeta } from "/opt/portal/xyy-web/src/pages/visa/article/[id].vue?macro=true";
import { default as _91id_93meAlk4ESHCMeta } from "/opt/portal/xyy-web/src/pages/visa/details/[id].vue?macro=true";
import { default as index_46client9Dxfe18zJZMeta } from "/opt/portal/xyy-web/src/pages/visa/index.client.vue?macro=true";
import { default as visaListsvafanBeLOMeta } from "/opt/portal/xyy-web/src/pages/visa/visaList.vue?macro=true";
import { default as _91id_93JVlMSGwCdsMeta } from "/opt/portal/xyy-web/src/pages/yj/[id].vue?macro=true";
export default [
  {
    name: "car",
    path: "/car",
    component: () => import("/opt/portal/xyy-web/src/pages/car/index.vue")
  },
  {
    name: "car-search",
    path: "/car/search",
    component: () => createClientPage(() => import("/opt/portal/xyy-web/src/pages/car/search.client.vue"))
  },
  {
    name: "car-submit-order",
    path: "/car/submit-order",
    component: () => createClientPage(() => import("/opt/portal/xyy-web/src/pages/car/submit-order.client.vue"))
  },
  {
    name: "chat-components-ActiveMessage",
    path: "/chat/components/ActiveMessage",
    component: () => import("/opt/portal/xyy-web/src/pages/chat/components/ActiveMessage.vue")
  },
  {
    name: "chat-components-ApplyJoinGroup",
    path: "/chat/components/ApplyJoinGroup",
    component: () => import("/opt/portal/xyy-web/src/pages/chat/components/ApplyJoinGroup.vue")
  },
  {
    name: "chat-components-ApplyJoinList",
    path: "/chat/components/ApplyJoinList",
    component: () => import("/opt/portal/xyy-web/src/pages/chat/components/ApplyJoinList.vue")
  },
  {
    name: "chat-components-Chat",
    path: "/chat/components/Chat",
    component: () => import("/opt/portal/xyy-web/src/pages/chat/components/Chat.vue")
  },
  {
    name: "chat-components-ChatHistory",
    path: "/chat/components/ChatHistory",
    component: () => import("/opt/portal/xyy-web/src/pages/chat/components/ChatHistory.vue")
  },
  {
    name: "chat-components-ChatList",
    path: "/chat/components/ChatList",
    component: () => import("/opt/portal/xyy-web/src/pages/chat/components/ChatList.vue")
  },
  {
    name: "chat-components-Complain",
    path: "/chat/components/Complain",
    component: () => import("/opt/portal/xyy-web/src/pages/chat/components/Complain.vue")
  },
  {
    name: "chat-components-ContextMenu",
    path: "/chat/components/ContextMenu",
    component: () => import("/opt/portal/xyy-web/src/pages/chat/components/ContextMenu.vue")
  },
  {
    name: "chat-components-CreateGroup",
    path: "/chat/components/CreateGroup",
    component: () => import("/opt/portal/xyy-web/src/pages/chat/components/CreateGroup.vue")
  },
  {
    name: "chat-components-FansList",
    path: "/chat/components/FansList",
    component: () => import("/opt/portal/xyy-web/src/pages/chat/components/FansList.vue")
  },
  {
    name: "chat-components-FriendInfo",
    path: "/chat/components/FriendInfo",
    component: () => import("/opt/portal/xyy-web/src/pages/chat/components/FriendInfo.vue")
  },
  {
    name: "chat-components-GroupInfo",
    path: "/chat/components/GroupInfo",
    component: () => import("/opt/portal/xyy-web/src/pages/chat/components/GroupInfo.vue")
  },
  {
    name: "chat-components-GroupIntro",
    path: "/chat/components/GroupIntro",
    component: () => import("/opt/portal/xyy-web/src/pages/chat/components/GroupIntro.vue")
  },
  {
    name: "chat-components-GroupQrCode",
    path: "/chat/components/GroupQrCode",
    component: () => import("/opt/portal/xyy-web/src/pages/chat/components/GroupQrCode.vue")
  },
  {
    name: "chat-components-GroupSetting",
    path: "/chat/components/GroupSetting",
    component: () => import("/opt/portal/xyy-web/src/pages/chat/components/GroupSetting.vue")
  },
  {
    name: "chat-components-GroupSquare",
    path: "/chat/components/GroupSquare",
    component: () => import("/opt/portal/xyy-web/src/pages/chat/components/GroupSquare.vue")
  },
  {
    name: "chat-components-GroupTips",
    path: "/chat/components/GroupTips",
    component: () => import("/opt/portal/xyy-web/src/pages/chat/components/GroupTips.vue")
  },
  {
    name: "chat-components-InviteGroup",
    path: "/chat/components/InviteGroup",
    component: () => import("/opt/portal/xyy-web/src/pages/chat/components/InviteGroup.vue")
  },
  {
    name: "chat-components-MsgStatus",
    path: "/chat/components/MsgStatus",
    component: () => import("/opt/portal/xyy-web/src/pages/chat/components/MsgStatus.vue")
  },
  {
    name: "chat-components-NewFans",
    path: "/chat/components/NewFans",
    component: () => import("/opt/portal/xyy-web/src/pages/chat/components/NewFans.vue")
  },
  {
    name: "chat-components-RemoveMember",
    path: "/chat/components/RemoveMember",
    component: () => import("/opt/portal/xyy-web/src/pages/chat/components/RemoveMember.vue")
  },
  {
    name: "chat-components-SetGroupType",
    path: "/chat/components/SetGroupType",
    component: () => import("/opt/portal/xyy-web/src/pages/chat/components/SetGroupType.vue")
  },
  {
    name: "chat-components-SystemMessage",
    path: "/chat/components/SystemMessage",
    component: () => import("/opt/portal/xyy-web/src/pages/chat/components/SystemMessage.vue")
  },
  {
    name: "chat-components-TextMsg",
    path: "/chat/components/TextMsg",
    component: () => import("/opt/portal/xyy-web/src/pages/chat/components/TextMsg.vue")
  },
  {
    name: "chat-const",
    path: "/chat/const",
    component: () => import("/opt/portal/xyy-web/src/pages/chat/const.js")
  },
  {
    name: "chat-emoji",
    path: "/chat/emoji",
    component: () => import("/opt/portal/xyy-web/src/pages/chat/emoji.js")
  },
  {
    name: "chat-followSta",
    path: "/chat/followSta",
    component: () => import("/opt/portal/xyy-web/src/pages/chat/followSta.js")
  },
  {
    name: "chat-friends_mock",
    path: "/chat/friends_mock",
    component: () => import("/opt/portal/xyy-web/src/pages/chat/friends_mock.js")
  },
  {
    name: "chat-groupTypeList",
    path: "/chat/groupTypeList",
    component: () => import("/opt/portal/xyy-web/src/pages/chat/groupTypeList.js")
  },
  {
    name: "chat",
    path: "/chat",
    component: () => import("/opt/portal/xyy-web/src/pages/chat/index.vue")
  },
  {
    name: "house-article-id",
    path: "/house/article/:id()",
    component: () => import("/opt/portal/xyy-web/src/pages/house/article/[id].vue")
  },
  {
    name: "house",
    path: "/house",
    component: () => createClientPage(() => import("/opt/portal/xyy-web/src/pages/house/index.client.vue"))
  },
  {
    name: "house-newHouse-id",
    path: "/house/newHouse/:id()",
    component: () => import("/opt/portal/xyy-web/src/pages/house/newHouse/[id].vue")
  },
  {
    name: "house-oldHouse-id",
    path: "/house/oldHouse/:id()",
    component: () => import("/opt/portal/xyy-web/src/pages/house/oldHouse/[id].vue")
  },
  {
    name: "house-rentHouse-id",
    path: "/house/rentHouse/:id()",
    component: () => import("/opt/portal/xyy-web/src/pages/house/rentHouse/[id].vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/opt/portal/xyy-web/src/pages/index.vue")
  },
  {
    name: "labour-detail-id",
    path: "/labour-detail/:id()",
    component: () => import("/opt/portal/xyy-web/src/pages/labour-detail/[id].vue")
  },
  {
    name: "labour",
    path: "/labour",
    component: () => import("/opt/portal/xyy-web/src/pages/labour/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: index_46clientrbucbSTYbxMeta || {},
    component: () => createClientPage(() => import("/opt/portal/xyy-web/src/pages/login/index.client.vue"))
  },
  {
    name: "note-create-start",
    path: "/note-create-start",
    component: () => createClientPage(() => import("/opt/portal/xyy-web/src/pages/note-create-start/index.client.vue"))
  },
  {
    name: "note-create",
    path: "/note-create",
    component: () => createClientPage(() => import("/opt/portal/xyy-web/src/pages/note-create/index.client.vue"))
  },
  {
    name: "note-create-success",
    path: "/note-create/success",
    component: () => import("/opt/portal/xyy-web/src/pages/note-create/success.vue")
  },
  {
    name: "other-people-center-components-addGroup",
    path: "/other-people-center/components/addGroup",
    component: () => import("/opt/portal/xyy-web/src/pages/other-people-center/components/addGroup.vue")
  },
  {
    name: "other-people-center",
    path: "/other-people-center",
    component: () => createClientPage(() => import("/opt/portal/xyy-web/src/pages/other-people-center/index.client.vue"))
  },
  {
    name: "profile-car-order-id",
    path: "/profile/car-order/:id()",
    component: () => createClientPage(() => import("/opt/portal/xyy-web/src/pages/profile/car-order/[id].client.vue"))
  },
  {
    name: "profile-components-followModal-followList",
    path: "/profile/components/followModal/followList",
    component: () => import("/opt/portal/xyy-web/src/pages/profile/components/followModal/followList.vue")
  },
  {
    name: "profile-components-followModal",
    path: "/profile/components/followModal",
    component: () => import("/opt/portal/xyy-web/src/pages/profile/components/followModal/index.vue")
  },
  {
    name: "profile-components-profileCollection-comments",
    path: "/profile/components/profileCollection/comments",
    component: () => import("/opt/portal/xyy-web/src/pages/profile/components/profileCollection/comments.vue")
  },
  {
    name: "profile-components-profileCollection-contentItem",
    path: "/profile/components/profileCollection/contentItem",
    component: () => import("/opt/portal/xyy-web/src/pages/profile/components/profileCollection/contentItem.vue")
  },
  {
    name: "profile-components-profileCollection-topics",
    path: "/profile/components/profileCollection/topics",
    component: () => import("/opt/portal/xyy-web/src/pages/profile/components/profileCollection/topics.vue")
  },
  {
    name: "profile-components-profileCollection-travelNotes",
    path: "/profile/components/profileCollection/travelNotes",
    component: () => import("/opt/portal/xyy-web/src/pages/profile/components/profileCollection/travelNotes.vue")
  },
  {
    name: "profile",
    path: "/profile",
    component: () => createClientPage(() => import("/opt/portal/xyy-web/src/pages/profile/index.client.vue")),
    children: [
  {
    name: "profile-index-car-orders",
    path: "car-orders",
    component: () => import("/opt/portal/xyy-web/src/pages/profile/index/car-orders.vue")
  },
  {
    name: "profile-index-collection",
    path: "collection",
    component: () => import("/opt/portal/xyy-web/src/pages/profile/index/collection.vue")
  },
  {
    name: "profile-index-labour-orders",
    path: "labour-orders",
    component: () => import("/opt/portal/xyy-web/src/pages/profile/index/labour-orders.vue")
  },
  {
    name: "profile-index-my-comment",
    path: "my-comment",
    component: () => import("/opt/portal/xyy-web/src/pages/profile/index/my-comment.vue")
  },
  {
    name: "profile-index-notes",
    path: "notes",
    component: () => import("/opt/portal/xyy-web/src/pages/profile/index/notes.vue")
  },
  {
    name: "profile-index-travel-orders",
    path: "travel-orders",
    component: () => import("/opt/portal/xyy-web/src/pages/profile/index/travel-orders.vue")
  },
  {
    name: "profile-index-visa-order-details-id",
    path: "visa-order-details/:id()",
    component: () => import("/opt/portal/xyy-web/src/pages/profile/index/visa-order-details/[id].vue")
  },
  {
    name: "profile-index-visa-orders",
    path: "visa-orders",
    component: () => import("/opt/portal/xyy-web/src/pages/profile/index/visa-orders.vue")
  },
  {
    name: "profile-index-wallet",
    path: "wallet",
    component: () => import("/opt/portal/xyy-web/src/pages/profile/index/wallet.vue")
  }
]
  },
  {
    name: "profile-travel-order-id",
    path: "/profile/travel-order/:id()",
    component: () => import("/opt/portal/xyy-web/src/pages/profile/travel-order/[id].vue")
  },
  {
    name: "profile-userinfo",
    path: "/profile/userinfo",
    component: () => import("/opt/portal/xyy-web/src/pages/profile/userinfo/index.vue")
  },
  {
    name: "t-id",
    path: "/t/:id()",
    component: () => import("/opt/portal/xyy-web/src/pages/t/[id].vue")
  },
  {
    name: "t",
    path: "/t",
    component: () => import("/opt/portal/xyy-web/src/pages/t/index.vue")
  },
  {
    name: "topic",
    path: "/topic",
    component: () => createClientPage(() => import("/opt/portal/xyy-web/src/pages/topic/index.client.vue"))
  },
  {
    name: "travel-notes",
    path: "/travel-notes",
    component: () => createClientPage(() => import("/opt/portal/xyy-web/src/pages/travel-notes/index.client.vue"))
  },
  {
    name: "travel-projects",
    path: "/travel-projects",
    component: () => import("/opt/portal/xyy-web/src/pages/travel-projects/index.vue")
  },
  {
    name: "visa-article-id",
    path: "/visa/article/:id()",
    component: () => import("/opt/portal/xyy-web/src/pages/visa/article/[id].vue")
  },
  {
    name: "visa-details-id",
    path: "/visa/details/:id()",
    component: () => import("/opt/portal/xyy-web/src/pages/visa/details/[id].vue")
  },
  {
    name: "visa",
    path: "/visa",
    component: () => createClientPage(() => import("/opt/portal/xyy-web/src/pages/visa/index.client.vue"))
  },
  {
    name: "visa-visaList",
    path: "/visa/visaList",
    component: () => import("/opt/portal/xyy-web/src/pages/visa/visaList.vue")
  },
  {
    name: "yj-id",
    path: "/yj/:id()",
    component: () => import("/opt/portal/xyy-web/src/pages/yj/[id].vue")
  }
]